import { create } from "zustand";

type CommonConfig = {
  id: string;
  created_at: string;
  updated_at: string | null;

  slug: string;
  table: string;
  name: string;
  desc: string;
  is_category: boolean;
  is_search: boolean;
  is_menu: boolean;
  list_count: number;
  page_count: number;
};

interface CommonConfigState {
  commonConfig: CommonConfig;
  setCommonConfig: (commonConfig: CommonConfig) => void;
}

export const useCommonConfigStore = create<CommonConfigState>((set) => ({
  commonConfig: {
    id: "",
    created_at: "",
    updated_at: null,

    slug: "",
    table: "",
    name: "",
    desc: "",
    is_category: false,
    is_search: false,
    is_menu: false,
    list_count: 0,
    page_count: 0,
  },
  setCommonConfig: (commonConfig: CommonConfig) => set({ commonConfig }),
}));
